import { jiomart } from "./theme.jiomart"
import { netmeds } from "./theme.netmeds"
import { tira } from "./theme.tira"
import { rd } from "./theme.rd"
import { ajio } from "./theme.ajio"

export const availableThemes = { jiomart, netmeds, tira, rd, ajio }
